import axios, { type AxiosInstance } from 'axios';
import { requestStarted, requestFinished } from './loading';

// Lokaliame dev'e — localhost:3000. Production'e (kai veikia per Caddy)
// — relatyvūs keliai per window.location.origin
const API_URL =
  import.meta.env.VITE_API_URL ??
  (typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? window.location.origin
    : 'http://localhost:3000');

export const api: AxiosInstance = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000,
});

// Automatiškai pridėti JWT token'ą + krovimo indikatorius
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ortholink_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  requestStarted();
  return config;
});

// Automatinis logout pasibaigus token'ui + krovimo indikatorius
api.interceptors.response.use(
  (response) => {
    requestFinished();
    return response;
  },
  (error) => {
    requestFinished();
    if (error.response?.status === 401) {
      localStorage.removeItem('ortholink_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
